import React from 'react';
import { Grid, CardContent, Typography, Card, Table, TableHead, TableBody, TableRow, TableCell, CardHeader } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import LazyBox from '../../../web/components/LazyBox';

//services
import AnalyticsAPI from '../../../services/api/Analytics';

class Dashboard extends React.Component {

	state = {
		informacoes:[],
		loading:true,
	}

	refreshDashboard = () => {
		const { enqueueSnackbar } = this.props;
			AnalyticsAPI.get()
						.then(res => {
							res.json().then(res => {
								if (res.msg) {
									this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
									return;
								}
								this.setState({ informacoes: res, loading:false })
								return;
							})
						}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel carregar a lista')))
	}

	componentDidMount(){
		this.refreshDashboard();
	}

    render() {
		const { informacoes, loading } = this.state;
		if( loading === true ){ return <LazyBox loading={loading} height="80vh" /> }
        return (
				<div className="app_control__content_padding" >
					<Grid container spacing={16} >
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{informacoes.usuarios_ativos}</Typography>
									<Typography variant="h6" >Visitantes ativos agora</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{informacoes.novos_usuarios}</Typography>
									<Typography variant="h6" >Novos visitantes </Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{informacoes.usuarios}</Typography>
									<Typography variant="h6" >Visitantes ultimos 30 dias</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={12} >
							<Card>
								<CardHeader title="Páginas abertas" subheader="Por visitantes ativos agora" />
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Quantidade</TableCell>
											<TableCell>Local</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{informacoes.paginas_usuarios_ativas.map((a, k) => <TableRow key={k} >
											<TableCell>{a.qtd}</TableCell>
											<TableCell>{a.local}</TableCell>
										</TableRow>)}
									</TableBody>
								</Table>
							</Card>
						</Grid>
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{Math.round(informacoes.sessoes_usuario)}</Typography>
									<Typography variant="h6" >Sessões por visitante</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{informacoes.paginas_visualizadas}</Typography>
									<Typography variant="h6" >Páginas visualizadas</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={4} >
							<Card>
								<CardContent style={{textAlign: 'center'}} >
									<Typography variant="h4" gutterBottom >{informacoes.paginas_compartilhadas}</Typography>
									<Typography variant="h6" >Páginas compartilhadas</Typography>
								</CardContent>
							</Card>
						</Grid>
						<Grid item xs={12} md={12} >
							<Card>
								<CardHeader title="Páginas visualizadas" subheader="Nos ultimos 30 dias" />
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Quantidade</TableCell>
											<TableCell>Local</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
									{informacoes.paginas_count_path.sort( (a,b) => b.qtd-a.qtd ).slice(0,20).map(( a, k ) => <TableRow key={k} >
											<TableCell>{a.qtd}</TableCell>
											<TableCell>{a.local}</TableCell>
										</TableRow>)}
									</TableBody>
								</Table>
							</Card>
						</Grid>
					</Grid>
				</div>
        );
    }
}

export default withSnackbar(Dashboard);



// WEBPACK FOOTER //
// ./src/painel/pages/dashboard/index.js